import { useEffect, useState } from 'react'
import CustomBreadcrumb from '../common/CustomBreadcrumb';
import Alert from '../common/Alert';
import { Button, Col, Container, Row } from 'react-bootstrap';
import ResponsiveTable from '../Grid/ResponsiveTable';
import InputBox from '../common/InputBox';
import SearchSelect from '../common/SearchSelect';
import { formatDateTime } from "../../helpers/date-formatter";
import Loader from '../common/loader';
import { getUnblockSerialNo, getActiveVendors, deleteUnblockSerialNumber } from '../../services/unblockSerialNumber-service';
import deleteIcon from "../../assets/delete.svg";

export default function UnblockSerialNoMaster() {

  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const [unblockSrNoObj, setUnblockSrNoObj] = useState({
    productCode: "",
    serialNumber: "",
    vendorCode: "",
    vendorName: "",
    financeCode: "",
  });

  const handleReset = () => {
    setUnblockSrNoObj({
      productCode: "",
      serialNumber: "",
      vendorCode: "",
      vendorName: "",
      financeCode: "",
    });
    setData([])
  }
 const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("handleChange - name:", name, "value:", value);
    
    if (name === "vendorCode") {
      const selectedVendor = options.find(vendor => vendor.vendorName === value);
      setUnblockSrNoObj((prevState) => ({
        ...prevState,
        vendorCode: selectedVendor?.vendorCode || "",
        vendorName: value
      }));
    } else {
      setUnblockSrNoObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  }

  const [headers] = useState([
    { displayName: "Product Code", columnName: "productCode", dataType: "text", width: 170, maxLength:50, displayIndication: true, required: true },
    { displayName: "Serial Number", columnName: "serialNumber", dataType: "text", width: 170, maxLength:50, displayIndication: true, required: true },
    { displayName: "Processed On", columnName: "createdOn", dataType: "date", width: 180, displayIndication: true, formatter: formatDateTime },
    { displayName: "Vendor Code", columnName: "vendorCode", dataType: "text", width: 160, maxLength:50, displayIndication: true, required: true },
    { displayName: "Finance Code", columnName: "financeCode", dataType: "text", width: 160, maxLength:50, displayIndication: true, required: true },
  ]);

  useEffect(() => {
        const fetchVendorsNames = async () => {
            setLoading(true);
            try {
                const data = await getActiveVendors();
                console.log("data in getActiveVendor", data);
                setOptions(data);
            } catch (error) {
                console.error("Error fetching vendor names:", error);
                setOptions([]);
            } finally {
                setLoading(false);
            }
        };

        fetchVendorsNames();
    }, [reload]);

  const getData = async () => {
    if (!unblockSrNoObj.productCode.trim()) {
      Alert("error", "Product Code is mandatory");
      return;
    }
    if (!unblockSrNoObj.serialNumber.trim()) {
      Alert("error", "Serial Number is mandatory");
      return;
    }
    if (!unblockSrNoObj.vendorCode.trim()) {
      Alert("error", "Vendor Code is mandatory");
      return;
    }
    if (!unblockSrNoObj.financeCode.trim()) {
      Alert("error", "Finance Code is mandatory");
      return;
    }
    
    setLoading(true)
    let result = await getUnblockSerialNo(unblockSrNoObj).catch((error) => {
      Alert("error", error.message || "An error occurred");
      return null;
    })
    console.log("getUnblockSerialNo result",result)
    if (result) {
      setData(result)
      if(result.length === 0){
        Alert("info", "No data found")
    }
  }
    setLoading(false)
  }

  const handleDelete = async (item) => {
    try {
      await deleteUnblockSerialNumber({ ...item, deletedBy: sessionStorage.getItem("Email") });
      const updatedData = data.filter((row, index) => index !== data.indexOf(item));
      setData(updatedData);
      Alert("success", "Record deleted successfully");
    } catch (error) {
      Alert("error", error.message || "Failed to delete record");
    }
  }

  let icons = [{ src: deleteIcon, click: handleDelete }]

  const commonProps = { onChange: handleChange }

  return (
    <div className="unblock-serial-no-master">
        {loading && <Loader/>}

      <CustomBreadcrumb parentMenu={"Maintenance"} menu={"Unblock Serial Number"}> </CustomBreadcrumb>
      <Container bsPrefix="main-body drop-down">
        <div className="page-title">Unblock Serial Number</div>
        <Row>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Product Code *" name="productCode" value={unblockSrNoObj.productCode} required {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Serial Number *" name="serialNumber" value={unblockSrNoObj.serialNumber} required {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Finance Code *" name="financeCode" value={unblockSrNoObj.financeCode} required {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <SearchSelect 
              label="Vendor Code *" 
              name="vendorCode" 
              value={unblockSrNoObj.vendorName}
              data={options}
              valueField="vendorName"
              labelField="vendorName"
              required
              onChange={handleChange}
              menuPortalTarget={document.body}
              menuPlacement="auto"
              menuPosition="absolute"
              isSearchable={false}
            />
          </Col>

          <Col className="display-action-btn"><Button onClick={handleReset} className="btn btn-outline-primary reset-button" variant="outline-primary">Reset</Button>
            <Button onClick={getData} className="btn btn-primary btn-color btn-go">Go</Button></Col>
        </Row>
        <ResponsiveTable  
          headers={headers} 
          data={data} 
          icons={icons} 
          DisplayExcelDownload={false} 
          dataType={"Logs"} 
          sessionName={"Unblock Serial Number"} 
          setReload={setReload} 
          reload={reload} 
          pageSize={5}
        ></ResponsiveTable>
      </Container>
    </div>
  )
}